// Matches skylab-sdk's own internal attribute (SK_THEME_ATTR in utils/theme.ts) - not exported
// from the package's public surface, so duplicated here rather than imported.
const SK_THEME_ATTR = 'data-sk-theme';

// Aviator Crush is a public, unauthenticated conference kiosk page designed to always show in
// dark mode - it must not follow the visitor's OS/account theme preference (PF-8881).
//
// AvaApp's own <s-theme-provider> can't be trusted to land on dark here: its fallback order is
// saved cookie > server-provided `themeAppearance` > light default, and none of those resolve to
// dark for this page - there's no cookie for a first-time visitor, and avaapp only sets
// `themeAppearance` when the visitor matches the `showThemeSwitcher` beta rollout, which an
// anonymous visitor never does. So this sets the same attribute directly instead of going
// through that provider.
// Restores the prior attribute value on cleanup - unlike hideShellChrome, this can't skip that:
// a SHOWAVIATORCRUSH flag flip to false re-renders PageNotFound in the same document (no
// navigation), and without restoring, that page would inherit the forced dark theme.
export const forceDarkTheme = (): (() => void) => {
  const previousValue = document.documentElement.getAttribute(SK_THEME_ATTR);
  document.documentElement.setAttribute(SK_THEME_ATTR, 'dark');

  return () => {
    if (previousValue === null) {
      document.documentElement.removeAttribute(SK_THEME_ATTR);
    } else {
      document.documentElement.setAttribute(SK_THEME_ATTR, previousValue);
    }
  };
};
